import { render, staticRenderFns } from "./StrukSubscription.vue?vue&type=template&id=fa6e0f0c&scoped=true&"
import script from "./StrukSubscription.vue?vue&type=script&lang=js&"
export * from "./StrukSubscription.vue?vue&type=script&lang=js&"
import style0 from "./StrukSubscription.vue?vue&type=style&index=0&id=fa6e0f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6e0f0c",
  null
  
)

export default component.exports